import React from 'react'
import { ThreeDots } from 'react-loader-spinner'
import classNames from 'classnames'

const SIZE_MAP = {
  sm: 40,
  md: 60,
  lg: 80,
  xl: 100,
}

const Loader = ({
  size = 'md',
  color = '#2563eb',
  fullscreen = false,
  overlay = false,
  className = '',
  visible = true,
}) => {
  if (!visible) return null

  const dimension = typeof size === 'number' ? size : SIZE_MAP[size] || SIZE_MAP.md

  const spinner = (
    <ThreeDots
      height={dimension}
      width={dimension}
      radius="9"
      color={color}
      ariaLabel="loading"
      visible={true}
    />
  )

  if (fullscreen) {
    return (
      <div
        className={classNames(
          'fixed inset-0 z-50 flex items-center justify-center',
          overlay ? 'bg-black/40' : 'bg-white',
          className,
        )}
      >
        {spinner}
      </div>
    )
  }

  return (
    <div className={classNames('flex w-full items-center justify-center py-6', className)}>
      {spinner}
    </div>
  )
}

export default Loader
